import React from 'react';

function SkeletonCard() {
  return (
    <section className="card-skeleton home-feed-card skeleton-box">
      <div className='header'>
        <span className="logo"></span>
      </div>
      <div className="body">
        <span className="title"></span>
        <span className="category"></span>
        <span className="vender"></span>
        <span className="desc-line"></span>
        <span className="desc-line"></span>
        <span className="desc-line"></span>
      </div>
      <div className='footer'>
        <span className="type"></span>
        <span className="bot-button"></span>
      </div>
    </section>
  );
}

export default SkeletonCard;